import { render, staticRenderFns } from "./SubpageAccountSettings.vue?vue&type=template&id=10d89250&scoped=true&"
import script from "./SubpageAccountSettings.vue?vue&type=script&lang=js&"
export * from "./SubpageAccountSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d89250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d89250')) {
      api.createRecord('10d89250', component.options)
    } else {
      api.reload('10d89250', component.options)
    }
    module.hot.accept("./SubpageAccountSettings.vue?vue&type=template&id=10d89250&scoped=true&", function () {
      api.rerender('10d89250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/accountsettings/SubpageAccountSettings.vue"
export default component.exports